export const TRANSLATION_KEYS = {
    AttachmentLabel: "ticketDetailsPage.detailsForm.attachmentLabel"
};